<template>
  <div class="">
    <div class="hero-background"></div>
    <div class="gradient-overlay"></div>
    <div class="row d-flex align-items-center justify-content-center vh-100">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <Card class="bg-white login-card shadow-lg">
          <div class="card-content p-4">
            <div class="text-center mb-4">
              <img src="../../../public/logo.png" width="100px" alt="logo" class="logo-animation">
              <h2 class="login-title mt-4 mb-1">Authentication</h2>
              <p class="text-muted">Securely signing you in</p>
            </div>

            <div class="mt-5 text-center">
              <div v-if="loading" class="auth-status">
                <div class="spinner-container mb-4">
                  <Spinner size="40" stroke="#0d6efd" spinner-class="mb-1" />
                </div>
                <p class="auth-message">Please wait while we verify your credentials and redirect you to the dashboard...</p>
              </div>
              <div v-if="error" class="auth-error">
                <div class="error-icon mb-3">
                  <i class="bi bi-exclamation-circle-fill text-danger" style="font-size: 2.5rem;"></i>
                </div>
                <h4 class="text-danger">Authentication Failed</h4>
                <p class="text-muted">{{ errorMessage }}</p>
                <button class="btn btn-primary mt-3" @click="goToLogin">
                  Return to Login
                </button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import authService from "@/api/authService";
import router from "@/router";
import notify from "@/utils/notify";

export default {
  name: "SSOAuth",

  data() {
    return {
      loading: true,
      error: false,
      errorMessage: "We couldn't authenticate you. Please try again."
    }
  },

  async created() {
    let token = this.$route.query.token
    if (token !== undefined && token !== '') {
      try {
        await authService.SSOAuth(token)
      } catch (error) {
        this.loading = false
        this.error = true
        this.errorMessage = error.message || "Authentication failed. Please try again."
        notify.alert.error(this.errorMessage)
      }
    } else {
      this.loading = false
      this.error = true
      this.errorMessage = "No authentication token provided."
      notify.alert.error(this.errorMessage)
    }
  },

  methods: {
    goToLogin() {
      router.push('/login')
    }
  }
}
</script>

<style scoped>
/* Hero Background */
.hero-background {
  background-image: url('@/assets/img/backgrounds/background.webp');
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  z-index: -2;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5) 5%, rgba(0,0,0,0.8) 100%);
  z-index: -1;
}

.login-card {
  border: none;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
}

.login-title {
  font-weight: 700;
  color: #333;
}

.logo-animation {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-status {
  padding: 1rem;
  border-radius: 8px;
  background-color: rgba(13, 110, 253, 0.05);
  border: 1px solid rgba(13, 110, 253, 0.1);
}

.auth-error {
  padding: 1.5rem;
  border-radius: 8px;
  background-color: rgba(220, 53, 69, 0.05);
  border: 1px solid rgba(220, 53, 69, 0.1);
}

.auth-message {
  color: #495057;
  font-size: 1rem;
}

.card-content {
  padding: 2rem;
}
</style>
